import axiosInstance from "./AxiosConfig";

class PackageDetail {
  async CreatePackage(data) {
    
    try {
      const response = await axiosInstance.post(`/packageDetail/create`, data);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetAllPackage() {
    try {
      const response = await axiosInstance.get(`/packageDetail/get`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetPackageById(id) {
    try {
      const response = await axiosInstance.get(`/packageDetail/getbyid/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdatePackageById(id, data) {
    try {
      const response = await axiosInstance.put(
        `/packageDetail/update/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async DeletePackageById(id) {
    try {
      const response = await axiosInstance.delete(
        `/packageDetail/delete/${id}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new PackageDetail();
